export default [
  { label: 'Cuenta Corriente', value: 'current_account' },
  { label: 'Cuenta Ahorro', value: 'savings_account' },
  { label: 'Cuenta Vista', value: 'view_account' }
];
